var j;
var k;
var q = (module.exports = {});
function v() {
  throw new Error("setTimeout has not been defined");
}
function w() {
  throw new Error("clearTimeout has not been defined");
}
function x(G) {
  if (j === setTimeout) {
    return setTimeout(G, 0);
  }
  if ((j === v || !j) && setTimeout) {
    j = setTimeout;
    return setTimeout(G, 0);
  }
  try {
    return j(G, 0);
  } catch (H) {
    try {
      return j.call(null, G, 0);
    } catch (I) {
      return j.call(this, G, 0);
    }
  }
}
(function () {
  try {
    j = typeof setTimeout == "function" ? setTimeout : v;
  } catch (G) {
    j = v;
  }
  try {
    k = typeof clearTimeout == "function" ? clearTimeout : w;
  } catch (H) {
    k = w;
  }
})();
var y;
var z = [];
var A = false;
var B = -1;
function C() {
  if (A && y) {
    A = false;
    if (y.length) {
      z = y.concat(z);
    } else {
      B = -1;
    }
    if (z.length) {
      D();
    }
  }
}
function D() {
  if (!A) {
    var G = x(C);
    A = true;
    for (var H = z.length; H; ) {
      y = z;
      z = [];
      while (++B < H) {
        if (y) {
          y[B].run();
        }
      }
      B = -1;
      H = z.length;
    }
    y = null;
    A = false;
    (function (I) {
      if (k === clearTimeout) {
        return clearTimeout(I);
      }
      if ((k === w || !k) && clearTimeout) {
        k = clearTimeout;
        return clearTimeout(I);
      }
      try {
        k(I);
      } catch (J) {
        try {
          return k.call(null, I);
        } catch (K) {
          return k.call(this, I);
        }
      }
    })(G);
  }
}
function E(G, H) {
  this.fun = G;
  this.array = H;
}
function F() {}
q.nextTick = function (G) {
  var H = Array(arguments.length - 1);
  if (arguments.length > 1) {
    for (var I = 1; I < arguments.length; I++) {
      H[I - 1] = arguments[I];
    }
  }
  z.push(new E(G, H));
  if (z.length === 1 && !A) {
    x(D);
  }
};
E.prototype.run = function () {
  this.fun.apply(null, this.array);
};
q.title = "browser";
q.browser = true;
q.env = {};
q.argv = [];
q.version = "";
q.versions = {};
q.on = F;
q.addListener = F;
q.once = F;
q.off = F;
q.removeListener = F;
q.removeAllListeners = F;
q.emit = F;
q.prependListener = F;
q.prependOnceListener = F;
q.listeners = function () {
  return [];
};
q.binding = function () {
  throw new Error("process.binding is not supported");
};
q.cwd = function () {
  return "/";
};
q.chdir = function () {
  throw new Error("process.chdir is not supported");
};
q.umask = function () {
  return 0;
};
